// theme.js
import { createBreakpoints } from "@chakra-ui/theme-tools"
export default createBreakpoints({
    sm: "480px", // 480
    md: "768px", // 768
    lg: "1200px", // 1200
    xl: "1380px", // 1440
    "2xl": "1920px", // 1920
})
